import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from './SEO';
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/FleetDetail.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserFriends,
  faCouch,
  faSuitcaseRolling,
  faBriefcase,
  faShieldAlt,
  faCar,
  faGasPump,
  faSnowflake,
  faWifi,
  faMusic,
  faPhone,
  faMapMarkedAlt,
  faGem,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

const FleetStretch = ({ currentLanguage }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Stretch Limo images for carousel
  const stretchImages = [
    "/images/stretch.avif",
    "/images/stretch.avif", // You can add more Stretch images here
    "/images/stretch.avif",
  ];

  const vehicleData = {
    EN: {
      title: "Stretch Limousine",
      subtitle: "Ultimate Luxury Experience",
      description: "Experience the pinnacle of luxury transportation with our stretch limousines. Perfect for special occasions, these vehicles feature premium amenities and unmatched elegance for an unforgettable journey.",
      specifications: {
        passengers: "Up to 10 Passengers",
        seats: "Luxury Leather Lounge Seating",
        largeLuggage: "6-8 Large Bags",
        carryOn: "10+ Carry-On Bags",
        fuelType: "Premium V8 Engine",
        transmission: "Smooth Automatic",
        airConditioning: "Multi-Zone Climate Control",
      },
      features: [
        "Premium leather lounge seating",
        "State-of-the-art entertainment system",
        "LED mood lighting",
        "Premium bar with glassware",
        "Privacy partition",
        "Fiber optic starlight ceiling",
        "Professional chauffeur in uniform",
        "Red carpet service available",
      ],
      perfectFor: [
        "Wedding ceremonies and receptions",
        "Prom and graduation celebrations",
        "Anniversary and romantic occasions",
        "VIP and celebrity transportation",
        "Bachelor/bachelorette parties",
        "Special milestone birthdays",
      ],
    },
    ES: {
      title: "Limusina Stretch",
      subtitle: "Experiencia de Lujo Definitiva",
      description: "Experimenta el pináculo del transporte de lujo con nuestras limusinas stretch. Perfectas para ocasiones especiales, estos vehículos cuentan con comodidades premium y elegancia inigualable para un viaje inolvidable.",
      specifications: {
        passengers: "Hasta 10 Pasajeros",
        seats: "Asientos de Salón de Cuero de Lujo",
        largeLuggage: "6-8 Maletas Grandes",
        carryOn: "10+ Equipajes de Mano",
        fuelType: "Motor V8 Premium",
        transmission: "Automático Suave",
        airConditioning: "Control de Clima Multi-Zona",
      },
      features: [
        "Asientos de salón de cuero premium",
        "Sistema de entretenimiento de última generación",
        "Iluminación LED de ambiente",
        "Bar premium con cristalería",
        "Partición de privacidad",
        "Techo de fibra óptica con estrellas",
        "Chofer profesional uniformado",
        "Servicio de alfombra roja disponible",
      ],
      perfectFor: [
        "Ceremonias y recepciones de boda",
        "Celebraciones de graduación y baile",
        "Aniversarios y ocasiones románticas",
        "Transporte VIP y de celebridades",
        "Fiestas de despedida de soltero/a",
        "Cumpleaños especiales de hitos",
      ],
    },
    AR: {
      title: "ليموزين طويلة",
      subtitle: "تجربة الفخامة المطلقة",
      description: "اختبر قمة النقل الفاخر مع ليموزيناتنا الطويلة. مثالية للمناسبات الخاصة، تتميز هذه المركبات بوسائل راحة متميزة وأناقة لا مثيل لها لرحلة لا تُنسى.",
      specifications: {
        passengers: "حتى 10 ركاب",
        seats: "مقاعد صالة جلدية فاخرة",
        largeLuggage: "6-8 حقائب كبيرة",
        carryOn: "10+ حقائب يد",
        fuelType: "محرك V8 متميز",
        transmission: "أوتوماتيكي ناعم",
        airConditioning: "تحكم مناخي متعدد المناطق",
      },
      features: [
        "مقاعد صالة جلدية متميزة",
        "نظام ترفيه متطور",
        "إضاءة LED مزاجية",
        "بار متميز مع أكواب زجاجية",
        "حاجز خصوصية",
        "سقف بالألياف البصرية بالنجوم",
        "سائق محترف بالزي الرسمي",
        "خدمة السجادة الحمراء متاحة",
      ],
      perfectFor: [
        "حفلات الزفاف والاستقبالات",
        "احتفالات التخرج والحفلة الراقصة",
        "ذكرى الزواج والمناسبات الرومانسية",
        "نقل VIP والمشاهير",
        "حفلات العزوبية",
        "أعياد ميلاد المعالم الخاصة",
      ],
    },
  };

  const data = vehicleData[currentLanguage] || vehicleData.EN;

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % stretchImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + stretchImages.length) % stretchImages.length);
  };

  return (
    <>
      <SEO 
        title="Stretch Limousine Service | Luxury Limo Rentals in Jacksonville"
        description="Luxury stretch limousine service in Jacksonville for weddings, proms, special events, and celebrations. Premium amenities with professional chauffeurs."
        keywords="stretch limousine Jacksonville, luxury limo rental, wedding limo, prom limo, special event transportation, celebration limo"
        canonical="/fleet/stretch"
      />
      <div className="fleet-detail-container">
        {/* Hero Section with Carousel */}
        <section className="fleet-detail-hero">
          <div className="fleet-carousel-container">
            <div className="fleet-carousel">
              <img
                src={stretchImages[currentImageIndex]}
                alt="Stretch Limousine"
                className="fleet-detail-image"
              />
              <div className="fleet-carousel-overlay"></div>
              
            {/* Carousel Controls */}
            <button className="fleet-carousel-btn prev" onClick={prevImage}>
              <span>‹</span>
            </button>
            <button className="fleet-carousel-btn next" onClick={nextImage}>
              <span>›</span>
            </button>
            
            {/* Carousel Indicators */}
            <div className="fleet-carousel-indicators">
              {stretchImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>
          
          {/* Hero Content */}
          <div className="fleet-hero-content">
            <h1 className="fleet-detail-title">{data.title}</h1>
            <p className="fleet-detail-subtitle">{data.subtitle}</p>
          </div>
        </div>
      </section>

      {/* Vehicle Details Section */}
      <section className="fleet-detail-content">
        <div className="container">
          <div className="row">
            {/* Description */}
            <div className="col-lg-8">
              <div className="fleet-description">
                <h2>About This Vehicle</h2>
                <p>{data.description}</p>
              </div>

              {/* Specifications */}
              <div className="fleet-specifications">
                <h3>Vehicle Specifications</h3>
                <div className="specs-grid">
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faUserFriends} className="spec-icon" />
                    <span>{data.specifications.passengers}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faGem} className="spec-icon" />
                    <span>{data.specifications.seats}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSuitcaseRolling} className="spec-icon" />
                    <span>{data.specifications.largeLuggage}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faBriefcase} className="spec-icon" />
                    <span>{data.specifications.carryOn}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faGasPump} className="spec-icon" />
                    <span>{data.specifications.fuelType}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faCar} className="spec-icon" />
                    <span>{data.specifications.transmission}</span>
                  </div>
                  <div className="spec-item">
                    <FontAwesomeIcon icon={faSnowflake} className="spec-icon" />
                    <span>{data.specifications.airConditioning}</span>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="fleet-features">
                <h3>Luxury Features</h3>
                <div className="features-grid">
                  {data.features.map((feature, index) => (
                    <div key={index} className="feature-item">
                      <FontAwesomeIcon icon={faStar} className="feature-icon" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Perfect For Sidebar */}
            <div className="col-lg-4">
              <div className="fleet-sidebar">
                <div className="perfect-for-card">
                  <h3>Perfect For</h3>
                  <ul className="perfect-for-list">
                    {data.perfectFor.map((occasion, index) => (
                      <li key={index}>
                        <FontAwesomeIcon icon={faMapMarkedAlt} className="list-icon" />
                        {occasion}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Card */}
                <div className="fleet-cta-card">
                  <h4>Ready to Book?</h4>
                  <p>Make your special occasion unforgettable.</p>
                  <Link to="/ReservationForm" className="fleet-cta-btn">
                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default FleetStretch;
